import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import useMenuFilterOptions from 'hooks/use-menu-filter-options';

import { MobileOnly } from 'shared/components';
import Menu from 'components/menu';
import { MainDispensaryLayout } from 'components/layouts/main-dispensary-layout';
import CategoryTilesGrid from 'components/category-tiles-grid';
import { BreadCrumbs } from 'src/components/bread-crumbs';
import useDispensaryCategories from 'src/dispensary/hooks/use-dispensary-categories';
import useDispensaryMenuSections from 'src/dispensary/hooks/use-dispensary-menu-sections';
import { WhoopsContent, WhoopsReason } from 'components/whoops';

import { GqlMenuSection } from 'types/graphql';
import { defaultFilters } from 'src/components/carousels/carousels.utils';

export function DispensaryCollectionPage(): JSX.Element | null {
  const { categories } = useDispensaryCategories();
  const { dispensary } = useDispensary();
  const { menuSections } = useDispensaryMenuSections();

  const router = useRouter();
  const { subcategories } = useMenuFilterOptions();
  const menuSection = menuSections.filter((section: GqlMenuSection) => section.id === router.query.menuSectionId)[0];

  const { products, loading, totalCount, totalPages } = useDispensaryProducts({
    filters: { ...defaultFilters, productIds: menuSection?.products },
    perPage: 100,
  });

  if (!dispensary) {
    return null;
  }

  if (!loading && !menuSection) {
    return <WhoopsContent reason={WhoopsReason.pageNotFound} />;
  }

  return (
    <>
      <MobileOnly>
        <BreadCrumbsContainer adjustForFilterPills={!!subcategories}>
          <BreadCrumbs lastCrumbLabel={menuSection?.label} />
        </BreadCrumbsContainer>
      </MobileOnly>

      <Menu
        totalCount={totalCount}
        totalPages={totalPages}
        products={products}
        loading={loading}
        dispensary={dispensary}
        displaySidebar={false}
        lastCrumbLabel={menuSection?.label}
        hideFilters
      />
      <CategoryTilesGrid p='35px 25px 70px' categories={categories} collapsible={false} />
    </>
  );
}

DispensaryCollectionPage.layout = MainDispensaryLayout;

const BreadCrumbsContainer = styled.div`
  padding-top: 25px;
  margin-bottom: ${({ adjustForFilterPills }) => (adjustForFilterPills ? `-16px` : '0')};
  padding-left: ${({ adjustForFilterPills }) => (adjustForFilterPills ? `3px` : '0')};
`;
